import React from 'react';
import axios from 'axios';
import './App.css';
import MainRoutes from './routes/Routes';
import { WebsiteProvider } from './context/WebsiteContext';
import { refreshBilling } from './admin/components/Features';
import { StorageGetItem, STORAGE_KEYS } from './admin/components/StorageComp';

// Any API call refused because the company is suspended sends company users to the
// suspension page (customers see the unavailable notice from withCustomerAuth instead)
axios.interceptors.response.use((response) => {
  if (response?.data?.code === "SERVICE_SUSPENDED") {
    const auth = StorageGetItem(STORAGE_KEYS.AUTH);
    const openPaths = ["/account-suspended", "/company-profile", "/my-profile"];
    if (auth && auth.user_type !== 1 && auth.user_type !== 5 && openPaths.indexOf(window.location.pathname) === -1) {
      refreshBilling().then(() => { window.location.href = "/account-suspended"; });
    }
  }
  return response;
});

function App() {
  return (<React.Fragment>
    <WebsiteProvider>
      <MainRoutes />
    </WebsiteProvider>
  </React.Fragment>);
}

export default App;
